<script setup lang="ts">
import { type PropType } from 'vue'

import { type Product, type ProductVariant } from '@/types';

const { addProductToCart } = useCart()

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productVariant: {
    type: Object as PropType<ProductVariant>,
    required: true,
  },
  quantity: {
    type: Number as PropType<number>,
    required: true,
  },
  quantityAvailable: {
    type: Number as PropType<number>,
    required: false
  }
})

const { product, productVariant, quantity } = toRefs(props)

const addToCartInterceptor = () => {
  if (product && productVariant) {
    addProductToCart(product.value, productVariant.value, quantity.value)
  }
}
</script>

<template>
  <!-- Start Add Product Variant To Cart Button -->
  <AddToCartButton 
    :product="product" 
    :disabled="quantityAvailable === 0"
    :display="'Add To Basket'"
    @click.native="addToCartInterceptor"
  />
  <!-- End Add Product Variant To Cart Button -->
</template>